import React from 'react';
import { useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { Header } from './Header';
import { Footer } from './Footer';
import { useAnalytics } from '../../hooks/useAnalytics';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  useAnalytics();
  const { pathname } = useLocation();
  const authShell = pathname === '/login' || pathname === '/callback';
  const showSymbolShell = pathname === '/show-symbol';

  return (
    <div className={clsx('layout', authShell && 'layout--auth', showSymbolShell && 'layout--show-symbol')}>
      <Header />
      <main className={clsx('layout-main', pathname === '/' && 'layout-main--home')}>{children}</main>
      <Footer />
    </div>
  );
};

